/**
 * @file 变压器管理
 */

import request from '@/utils/request'

/**
 * @typedef {Object} Transformer 变压器对象
 * @property {string|number} [id] 变压器Id
 * @property {string|number} stationId 电站Id
 * @property {string} [uuid] 设备UUID（唯一标识）
 * @property {string} devId 设备ID（设备编码）
 * @property {string|number} [unitId] 电站单元ID
 * @property {string} transformerName 变压器名称
 * @property {string} [manufactorName] 厂家名称
 * @property {string} [productModel] 产品型号
 * @property {string} [serialNumber] 出厂编号
 * @property {string} [manufactureTime] 出厂时间
 * @property {string|number} [parentEquipmentId] 关联设备ID
 * @property {string} ratedCapacity 额定容量
 * @property {string} [voltageLevel] 电压等级
 * @property {string} [inputVoltage] 输入电压
 * @property {string} [outputVoltage] 输出电压
 * @property {string} [medium] 绝缘散热介质
 * @property {string} [coreStructure] 铁芯结构
 */

/**
 * 修改变压器
 * @param {Transformer} transformer
 */
export function updateTransformer(transformer) {
  return request({
    url: '/device/v3/transformer',
    method: 'put',
    data: transformer
  })
}

/**
 * 新增变压器
 * @param {Transformer} transformer
 */
export function addTransformer(transformer) {
  return request({
    url: '/device/v3/transformer',
    method: 'post',
    data: transformer
  })
}

/**
 * 获取变压器列表
 * @param {object} params
 * @param {string|number} params.stationId
 * @param {string} [params.transformerName]
 * @param {string} [params.productModel]
 * @param {string|number} [params.pageNum]
 * @param {string|number} [params.pageSize]
 */
export function getTransformerList(params) {
  return request({
    url: '/device/v3/transformer/list',
    method: 'get',
    params: params
  })
}

/**
 * 批量删除变压器
 * @param {string|number|string[]|number[]} ids 变压器Id
 */
export function delTransformerList(ids) {
  if (Array.isArray(ids)) {
    ids = ids.join(',')
  }
  return request({
    url: `/device/v3/transformer/${ids}`,
    method: 'delete',
  })
}

/**
 * 获取变压器详细信息
 * @param {string|number} id 变压器Id
 */
export function getTransformer(id) {
  return request({
    url: `/device/v3/transformer/${id}`,
    method: 'get',
  })
}
